// extracted by mini-css-extract-plugin
module.exports = {"container":"biomarkers-container-module__container___3OYyn","footnote":"biomarkers-container-module__footnote___15rio"};